"use strict";
console.warn('copyText has been migrated to an npm module called "copy-text". Please use that instead.');
module.exports = require('copy-text');



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/helpers/copyText.js
// module id = 380
// module chunks = 4 6 7 8 9 12 17 19 55 56